// extracted by mini-css-extract-plugin
export default {"validationErrors":"Mailbox_validationErrors__8lXUH","alertBox":"Mailbox_alertBox__xpLRW","dangerAlert":"Mailbox_dangerAlert__h1RjW"};